import { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import { useTranslation } from "react-i18next";

type FAQItem = {
  question: string;
  answer: string;
};


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const { t } = useTranslation();

  const faqs: FAQItem[] = [
    {
      question: t("faqs.faq-1"),
      answer: t("faqs.faq-1 description")
    },
    {
      question: t("faqs.faq-2"),
      answer: t("faqs.faq-2 description")
    },
    {
      question: t("faqs.faq-3"),
      answer: t("faqs.faq-3 description")
    },
    {
      question: t("faqs.faq-4"),
      answer: t("faqs.faq-4 description")
    },
    {
      question: t("faqs.faq-5"),
      answer: t("faqs.faq-5 description")
    },
    {
      question: t("faqs.faq-6"),
      answer: t("faqs.faq-6 description")
    },
    {
      question: t("faqs.faq-7"),
      answer: t("faqs.faq-7 description")
    },
    {
      question: t("faqs.faq-8"),
      answer: t("faqs.faq-8 description")
    },
    {
      question: t("faqs.faq-9"),
      answer: t("faqs.faq-9 description")
    },
    {
      question: t("faqs.faq-10"),
      answer: t("faqs.faq-10 description")
    }
  ];
 

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-2 lg:py-10 px-[20px] lg:px-20 xl:px-40 2xl:px-64 mb-6 ">
      <h2 className="text-center text-[22px] lg:text-[32px] font-bold text-textTitle mb-6">
       {t("faqs.faq-title")}
      </h2>
      <div className="mx-auto grid grid-cols-1 md:grid-cols-2 gap-2 lg:gap-6">
        {faqs.map((item: FAQItem, index: number) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-lg mb-0 2xl:mb-4 border border-gray-200"
          >
            <div
              className="flex justify-between items-center p-4 cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <h3 className="text-[12px] lg:text-[14px] font-semibold text-textTipic">
                {item.question}
              </h3>
              <span className="text-gray-600">
                {activeIndex === index ? (
                  <FiMinus className="transition-transform duration-300" />
                ) : (
                  <FiPlus className="transition-transform duration-300" />
                )}
              </span>
            </div>
            {activeIndex === index && (
              <div className="px-4 pb-4 text-gray-600">{item.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
